<template>
  <div style="display: flex; justify-content: center; align-items: center">
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue'
export default {
  data() {
    return {
      cdata: [
        {
          name: '武汉市',
          value: 8,
          elseData: [{ key: '产量', value: 999 }]
        },
        {
          name: '十堰市',
          value: 2,
          elseData: [{ key: '产量', value: 999 }]
        },
        {
          name: '神农架林区',
          value: 3,
          elseData: [{ key: '产量', value: 999 }]
        },
        {
          name: '恩施土家族苗族自治州',
          value: 4,
          elseData: [{ key: '产量', value: 999 }]
        },
        {
          name: '襄阳市',
          value: 5,
          elseData: [{ key: '产量', value: 999 }]
        },
        {
          name: '宜昌市',
          value: 6,
          elseData: [{ key: '产量', value: 999 }]
        },
        {
          name: '随州市',
          value: 7,
          elseData: [{ key: '产量', value: 999 }]
        },
        {
          name: '荆门市',
          value: 8,
          elseData: [{ key: '产量', value: 999 }]
        },
        {
          name: '荆州市',
          value: 9,
          elseData: [{ key: '产量', value: 999 }]
        },
        {
          name: '孝感市',
          value: 10,
          elseData: [{ key: '产量', value: 999 }]
        },
        {
          name: '天门市',
          value: 11,
          elseData: [{ key: '产量', value: 999 }]
        },
        {
          name: '潜江市',
          value: 12,
          elseData: [{ key: '产量', value: 999 }]
        },
        {
          name: '仙桃市',
          value: 13,
          elseData: [{ key: '产量', value: 999 }]
        },
        {
          name: '咸宁市',
          value: 14,
          elseData: [{ key: '产量', value: 999 }]
        },
        {
          name: '黄石市',
          value: 15,
          elseData: [{ key: '产量', value: 999 }]
        },
        {
          name: '鄂州市',
          value: 16,
          elseData: [{ key: '产量', value: 999 }]
        },
        {
          name: '黄冈市',
          value: 17,
          elseData: [{ key: '产量', value: 999 }]
        }
      ]
    }
  },
  components: {
    Chart
  },
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped></style>
